import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-gdo-connected-garage-features-dialog',
    templateUrl: './gdo-connected-garage-features-dialog.component.html',
    styleUrls: ['./gdo-connected-garage-features-dialog.component.scss'],
    standalone: false
})
export class GdoConnectedGarageFeaturesDialogComponent implements OnInit {

  hideCancelButton:Boolean =true;

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<GdoConnectedGarageFeaturesDialogComponent>,
  ) { }
  
  ngOnInit(): void {
    this.hideCancelButton = false
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAccept(): void {
    this.dialogRef.close();
  }

  onClickClose() {
    this.dialogRef.close();
  }

}